module.exports = __webpack_public_path__ + "media/images/application/template/logos/mpba-logo-654ac5d1ebdeec7b5445f2873d162171.png";